import * as React from "react";
const SvgFiRrStocking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stocking_svg__a)">
      <path
        fill="#062147"
        d="M23 0H8a1 1 0 0 0 0 2h1v5.873c0 .848-.538 1.606-1.338 1.887l-2.915 1.023A6.77 6.77 0 0 0 .31 19.254 6.73 6.73 0 0 0 6.761 24q1.027.001 2.041-.317l7.083-2.396A8.995 8.995 0 0 0 22 12.762V2.001h1A1 1 0 0 0 23 0m-3 12.761a7 7 0 0 1-4.756 6.63l-7.062 2.39c-.462.145-.94.218-1.422.218a4.74 4.74 0 0 1-4.543-3.342c-.782-2.507.62-5.183 3.158-5.976l2.948-1.034A4 4 0 0 0 11 7.873V2h9v10.762z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stocking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStocking;
